import { memo } from "react";
import "./index.scss";

const Ins = () => {
  return (
    <div className="page processIndex">
      <div className="upgrade-text">温馨提示：尊敬的客户，服务升级中，敬请期待！</div>
    </div>
  )
}

export default memo(Ins);
